function moveTaskDialog () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/move-task/move-task-dialog.html?$$REVISION$$'
  }
}
export { moveTaskDialog }
